import { LabelBinding, ResponseDataOfGetTelemetryResponse } from '@monorepo-types/dc/smartthermostat';

import { request } from '../../client';
import type { ApiRequestConfig } from '../../client/types';

type GetTelemetry = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  locationId: string;
  masterId: string;
};
/**
 *
 *
 * @returns ResponseDataOfGetTelemetryResponse OK
 */
export function getTelemetry(
  { businessUnit, label, customerId, accountId, locationId, masterId }: GetTelemetry,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfGetTelemetryResponse> {
  return request(
    {
      method: 'GET',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/locations/${locationId}/hosts/${masterId}/telemetry`,
      errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found',
        412: 'Precondition Failed',
        500: 'Internal Server Error',
      },
    },
    requestConfig,
  );
}
